import { GetLoggedInUserId } from "../Helpers/Utilities";
import webServiceWrapper from "./webServiceWrapper";

const AuthenticateJWTToken = () => {
  return webServiceWrapper.get(`/login/AuthenticateJWTToken`);
};

const AuthenticateUser = (payload) => {
  return webServiceWrapper.post(
    `/login/AuthenticateUser`,
    payload,
    6 * 60 * 1000,
  );
};

const RegisterUser = (payload) => {
  return webServiceWrapper.post(`/login/RegisterUser`, payload);
};

const Logout = () => {
  return webServiceWrapper.get(`/login/Logout`);
};

const GetUserDetails = (userGUID) => {
  return webServiceWrapper.get(`/login/GetUserDetails?userGUID=${userGUID}`);
};

const GetProfileSync = (userGUID) => {
  return webServiceWrapper.get(`/login/GetProfileSync?userGUID=${userGUID}`);
};

const UploadUserProfile = (payload) => {
  return webServiceWrapper.post(`/login/UploadUserProfile`, payload);
};

const CheckUserSubscription = (userGUID) => {
  return webServiceWrapper.get(
    `/login/CheckUserSubscription?userGUID=${userGUID}`,
  );
};

const AuthenticateSSNETUser = (payload) => {
  return webServiceWrapper.post(
    `/login/AuthenticateSSNETUser`,
    payload,
    900000,
  );
};

const UnsubscribeUser = (payload) => {
  return webServiceWrapper.post("/login/UnsubscribeUser", payload);
};

const IsUserUnsubscribed = (payload) => {
  return webServiceWrapper.post("/login/IsUserUnsubscribed", payload);
};

const IsUserActive = (userGUID = GetLoggedInUserId()) => {
  return webServiceWrapper.post("/login/IsUserActive", {
    userGUID,
  });
};

const GetToken = () => {
  return webServiceWrapper.get(`/login/GetToken`, {
    credentials: "include",
  });
};

export const loginService = {
  AuthenticateUser,
  RegisterUser,
  Logout,
  AuthenticateJWTToken,

  UploadUserProfile,
  CheckUserSubscription,
  GetUserDetails,
  AuthenticateSSNETUser,

  GetProfileSync,

  UnsubscribeUser,
  IsUserUnsubscribed,
  IsUserActive,
  GetToken,
};
